// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DashboardDBObjectController = function ($scope, DBObjects) {
    $scope.id = "";
    $scope.addObject = function () {
        DBObjects.get({ objectid: $scope.id }, function (data) {
            if (data) {
                data.Url = getUrl(data);
                data.showDetails = true;
                data.objectIdTimestamp = new Date(parseInt(data.Id.substring(0, 8), 16) * 1000).toISOString();
                $scope.objects.push(data);
            }
        });
    };

    var getUrl = function (data) {
        if (data.Type == "Contract") {
            return "/#/entities/" + data.Data.Owner.EntityId + "/customers/" + data.Data.CustomerId;
        }
        else if (data.Type == "Customer") {
            return "/#/entities/" + data.Data.Owner.EntityId + "/customers/" + data.Data.Id;
        }
        else if (data.Type == "PaymentTransaction") {
            return "/#/payments?customerId=" + data.Data.CustomerId;
        }
    }

    $scope.reset = function () {
        $scope.objects = [];
    };

    $scope.collapseAll = function () {
        $scope.objects.forEach(function (object) {
            object.showDetails = false;
        });
    };

    $scope.reset();
};
DashboardDBObjectController.$inject = ['$scope', 'DBObjects'];
